(function() {
  function initSwipers() {
    const containers = document.querySelectorAll('.image-with-products-swiper');
    
    containers.forEach(container => {
      const sectionId = container.dataset.sectionId;
      
      new Swiper(container, {
        slidesPerView: 1,
        spaceBetween: 20,
        loop: false,
        grabCursor: true,
        keyboard: {
          enabled: true,
          onlyInViewport: true,
        },
        breakpoints: {
          768: {
            enabled: false,
            slidesPerView: 'auto',
          }
        }
      });
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initSwipers);
  } else {
    initSwipers();
  }
})();
